<template>
  <b-row align-v="start" no-gutters>
    <b-col v-if="productImageUrl" cols="auto">
      <b-link href="#links-goes-here">
        <b-img alt="" class="img-border product-image" :src="productImageUrl" />
      </b-link>
    </b-col>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <b-col class="ml-2" v-html="homeSafeFormattedProductName"></b-col>
    <b-col>
      <h3 class="my-0 text-right">
        <span :style="{ textDecoration: Number(item.subtotal) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
          {{ $n(item.subtotal, 'currency') }}
        </span>
        <span v-if="Number(item.subtotal) !== Number(item.subtotal - item.discount)" class="ml-1">
          <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
          <span v-else>{{ $t('components.totals.free') }}</span>
        </span>
      </h3>
      <b-button block class="m-0 p-0 text-right" variant="link" @click="$emit('remove-item', orderItemId)">remove</b-button>
    </b-col>
  </b-row>
</template>

<script>
import { getImage } from '@/utils';

export default {
  name: 'PetTrackingDeviceProduct',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    homeSafeFormattedProductName() {
      return this.productName.replaceAll('HomeSafe', 'Home<span class="font-italic">Safe</span>').replaceAll('®', '<sup>&reg;</sup>');
    },
    productImageUrl() {
      return this.item.product.image ? getImage(this.item.product.image.original) : null;
    },
    orderItemId() {
      return this.item.id;
    },
    productName() {
      return this.item.product.name;
    },
  },
  methods: {
    getImage,
  },
};
</script>

<style scoped></style>
